import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as groupedProductsState from '../employee-detail.reducer';
import * as groupedProductsReducer from '../reducers/grouped-products.reducer';

export const getGroupedProducts = createSelector(
  groupedProductsState.getGroupedProductsState,
  groupedProductsReducer.getGroupedProductsResponse
);
